import React, { useState, useEffect } from "react";
import {
  Text,
  Textarea,
  Input,
  Stack,
  HStack,
  Grid,
  Button,
  Select,
} from "@chakra-ui/react";
import request from "../utils/request";

const SendEmail = () => {
  const [templates, updateTemplates] = useState([]);
  const [selected, select] = useState(0);
  const [currentTemplate, updateCurrentTemplate] = useState({
    template_name: "",
    template_subject: "",
    template_body: "",
    email: "",
    file: "",
  });

  useEffect(() => {
    if (templates.length > 0) {
      updateCurrentTemplate((prev) => ({ ...prev, ...templates[selected] }));
    }
  }, [templates, selected]);

  useEffect(() => {
    //fetch all templates
    getAllTemplates()
      .then((data) => updateTemplates(data))
      .catch(() => {});
  }, []);

  const getAllTemplates = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await request.get({
          from: "/student/template/get/",
          useToken: true,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  const handleClick = (e) => {
    updateCurrentTemplate({
      ...currentTemplate,
      [e.target.name]: e.target.value,
    });
  };

  const handleFile = (e) => {
    try {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file); //converts file to an url
      reader.onloadend = () => {
        updateCurrentTemplate({ ...currentTemplate, file: reader.result });
      };
    } catch (error) {
      // Error handled silently
    }
  };

  const sendEmail = () => {
    // TODO: Implement email sending
  };

  const discard = () => {
    updateCurrentTemplate({ ...currentTemplate, email: "", file: "" });
  };
  return (
    <>
      <Text fontWeight="semibold" textAlign="left">
        Send email
      </Text>
      <Stack py="8" spacing="6">
        <Grid templateColumns="1fr 2fr">
          <Text pr="8">Email template</Text>
          <Select
            name="selected"
            value={selected}
            onChange={(e) => select(e.target.value)}
          >
            {templates.map((template, index) => (
              <option value={index} key={index}>
                {template.template_name}
              </option>
            ))}
          </Select>
        </Grid>
        <Grid templateColumns="1fr 2fr">
          <Text pr="8">Email address</Text>
          <Input
            type="email"
            name="email"
            value={
              templates.length > 0 && Object.keys(currentTemplate).length > 0
                ? currentTemplate.email
                : ""
            }
            onChange={handleClick}
          />
        </Grid>
        <Grid templateColumns="1fr 2fr">
          <Text pr="8">Subject</Text>
          <Input
            type="text"
            value={
              templates.length > 0 && Object.keys(currentTemplate).length > 0
                ? currentTemplate.template_subject
                : ""
            }
            onChange={handleClick}
            name="template_name"
          />
        </Grid>
        <Grid templateColumns="1fr 2fr">
          <Text pr="8">Body</Text>
          <Textarea
            rows={10}
            value={
              templates.length > 0 && Object.keys(currentTemplate).length > 0
                ? currentTemplate.template_body
                : ""
            }
            onChange={handleClick}
            name="template_body"
          />
        </Grid>
        <Grid templateColumns="1fr 2fr">
          <Text pr="8">Attach File</Text>
          <Input type="file" name="file" onChange={handleFile} />
        </Grid>
      </Stack>
      <HStack width="100%">
        <Button
          variant="outline"
          color="brand.orange"
          backgroundColor="white"
          width="100%"
          onClick={discard}
        >
          Discard
        </Button>
        <Button
          variant="solid"
          backgroundColor="brand.orange"
          color="white"
          width="100%"
          onClick={sendEmail}
        >
          Send email
        </Button>
      </HStack>
    </>
  );
};

export default SendEmail;
